import {Component, OnInit} from '@angular/core';
import {AlertService, GroupService, UserService} from "../services";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {CustomerSourceService} from "../services/customerSource.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {User} from "../models";
import {CardService} from "../services/card.service";
import {Card} from "../models/card";
import {ServiceService} from "../services/service.service";
import {Service} from "../models/service";
import {Services} from "../models/services";

@Component({
    templateUrl: './addCardItem.component.html',
    styleUrls: ['./addCardItem.component.scss']
})

export class AddCardItemComponent implements OnInit {
    form: FormGroup;
    user: User;
    card: Card;
    services: Service[];
    id: string;
    submitted = false;
    loading = false;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private serviceService: ServiceService,
        private alertService: AlertService,
        private customerSourceService: CustomerSourceService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private cardService: CardService
    ) {

        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Customers');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['cardId'];
        this.user = this.route.snapshot.data.userData;
        this.card = this.route.snapshot.data.cardData;

        this.serviceService.getAll()
            .pipe(first())
            .subscribe((x: Services) => {
                this.services = x.items;
            });

        this.form = this.formBuilder.group({
            cardNumber: [this.card.cardNumber, Validators.required],
            serviceName: [''],
            serviceId: [''],
            service: [''],
            expirationDate: ['', Validators.required],
            balance: ['', Validators.required],
            orderId: [''],
        });

        // this.f.userId.setValue(this.id);
    }

    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        this.addCartItem();
    }

    private addCartItem() {
        let formData = this.form.value;
        this.cardService.addItem(this.card.uuid, formData.cardNumber, formData.serviceName, formData.serviceId, formData.balance, formData.orderId, formData.expirationDate)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Added successful', { keepAfterRouteChange: true });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }

    onDateChange(date: any) {
        var d = date.value;
        var month = (d.getMonth()+1).toString();
        var day = d.getDate().toString();
        if (month.length<2) {
            month = '0' + month;
        }
        if (day.length<2) {
            day = '0' + day;
        }
        var datestring = d.getFullYear() + "-" + month  + '-'  + day;
        this.form.controls['expirationDate'].setValue(datestring);
    }

    setService(service: Service) {
        this.form.controls['serviceId'].setValue(null);
        this.form.controls['serviceName'].setValue(null);

        if (service) {
            this.form.controls['serviceId'].setValue(service.id);
            this.form.controls['serviceName'].setValue(service.name);
        }
    }
}
